import { render, staticRenderFns } from "./industry-form.vue?vue&type=template&id=37417ba0&scoped=true&"
import script from "./industry-form.vue?vue&type=script&lang=js&"
export * from "./industry-form.vue?vue&type=script&lang=js&"
import style0 from "./industry-form.vue?vue&type=style&index=0&id=37417ba0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37417ba0",
  null
  
)

export default component.exports